import { IComponentOptions, IController, ITimeoutService } from 'angular';
import uniqueId from 'lodash-es/uniqueId';
import { $Event } from '../../../helpers';
import './gmc-switch-inner.component.scss';

export class GmcSwitchInnerController implements IController {
  static $inject = [ '$timeout' ];
  changed: ( $event ) => void;
  value: boolean;
  type: 'inner' | 'outer';
  id = uniqueId();

  constructor( private $timeout: ITimeoutService ) {
  }

  onChange() {
    this.$timeout(() => {
      this.changed(new $Event({ value: this.value }));
    });
  }
}

export const GmcSwitchInnerComponent: IComponentOptions = {
  controller: GmcSwitchInnerController,
  template: require('./gmc-switch-inner.component.html'),
  bindings: {
    value: '=?',
    name: '@',
    changed: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-switch-inner/gmc-switch-inner.component.ts